




































































import { Inject, Component, Vue } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import { Listitem } from '@/data/models/listitem.model';
import EditListItem from './listitem/EditListItem.vue';

@Component
export default class ListItemsList extends Vue {
	@Inject('CrudService') listitemCrudService!: CrudService<Listitem>;
	
	rows: Listitem[] = [];
	advancedSearch: Search = new Search('selistitem');
	loading: boolean = false;
	parentid!: number;

	constructor() {
		super();
	}

	loadListItems() {
		this.listitemCrudService
			.searchEntities(
				Listitem,
				'selistitem',
				this.advancedSearch,
				this.advancedSearch.page
			)
			.then((results) => {
				this.rows = results;
			});
	}

	editListItem(item: Listitem) {
		this.openListItem(item);
	}

	openListItem(item: Listitem) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditListItem,
			props: {
				listitem: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Listitem) => {
					this.listitemCrudService
						.saveEntity(Listitem, 'selistitem', value)
						.then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							this.loadListItems();
							modal.close();
						})
						.catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
				},
			},
		});
	}

	deleteListItem(item: Listitem) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-listitem-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			onConfirm: () => {
				this.listitemCrudService
					.deleteEntity(Listitem, 'selistitem', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.loadListItems();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadListItems();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadListItems();
	}

	beforeMount() {
		this.parentid = parseInt(this.$route.params.id);
		if (this.parentid) {
			this.advancedSearch.addSimpleFilter('lid', this.parentid);
			this.loadListItems();
		}
	}
}
